export default {
  base_url: 'https://api.ronad.ir/v1',
  warehouses: [
    {"id":4,
    "name":"انبار غرب تهران",
    "phoneNumber":"02153850111",
    "city":"تهران","zipCode":"1378795599",
    "lat":35.72242005717942,"lon":51.18169784545899,"capacity":15000,
    "workDays":"شنبه تا پنجشنبه","workTimes":"8-20",
    "province":"تهران","address":"شادآباد-خ ۱۷ شهریور بین بسیج و شهدای اسلام پلاک ۳۴۴",
    "adminId":1092,"parentId":null,
    "centerId":null,"cityId":5,"status":"ACTIVE"
    },
    {"id":664,"name":"انبار FMCG","phoneNumber":"02177336655",
    "city":"تهران","zipCode":null,"lat":0.0,"lon":0.0,"capacity":1000,
    "workDays":"شنبه الی چهارشنبه","workTimes":"8 الی 17","province":"تهران",
    "address":"شادآباد-خ ۱۷ شهریور بین بسیج و شهدای اسلام پلاک ۳۴۴",
    "adminId":1294,"parentId":null,"centerId":null,"cityId":5,
    "status":"ACTIVE"},{"id":696,"name":"داخلی روناد",
    "phoneNumber":"02177362545","city":"تهران","zipCode":null,
    "lat":0.0,"lon":0.0,"capacity":20000,"workDays":"شنبه الی چهارشنبه",
    "workTimes":"8 الی 17","province":"تهران",
    "address":"بلوار مرزداران خیابان ایثار کوچه نامدار شش پلاک ۲ واحد ۶",
    "adminId":1411,"parentId":null,
    "centerId":null,"cityId":5,
    "status":"ACTIVE"
  }],
  destinationId: 4,
  centerId: 2900
};
